module.exports = __webpack_public_path__ + "img/57.4bf08c3c.jpg";